export default __webpack_public_path__ + "static/media/saltala-blue.6b19b7fc.svg";